module.exports = __webpack_public_path__ + "img/2_272.e86d26e8.png";